var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var Gamefield = /** @class */ (function (_super) {
    __extends(Gamefield, _super);
    function Gamefield() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Gamefield.prototype.render = function () {
        return (React.createElement("div", { className: "rj-baseball-scoreboard-gamefield" },
            React.createElement("div", { className: "rj-baseball-scoreboard-gamefield-heading" }, this.props.heading),
            React.createElement("div", { className: "rj-baseball-scoreboard-gamefield-content" },
                React.createElement("div", { className: "rj-baseball-scoreboard-gamefield-diamond" }, this.props.children))));
    };
    return Gamefield;
}(React.Component));
export { Gamefield };
//# sourceMappingURL=Gamefield.js.map